export enum TipoVotacaoEnum {
  Enquete = "4318E320-B5BF-4C3D-84A9-51AFD8E47F38",
  Assembleia = "4318E320-B5BF-4C3D-84A9-51AFD8E47F39",
}

export enum AmbienteVotacaoEnum {
  Remota = "C2D2F841-4619-40C0-BB5E-CDB294EA9197",
  Hibrida = "C2D2F841-4619-40C0-BB5E-CDB294EA9198",
  Presencial = "C2D2F841-4619-40C0-BB5E-CDB294EA9199",
}
